import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import YTable from '@/views/components/table/index.vue';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
import { findReportOrder, createReportOrder, updateReportOrder, updateReportOrderState, deleteReportOrder, listReportOrderDetail, findReportOrderDetail, createReportOrderDetails, updateReportOrderDetail, deleteReportOrderDetail } from '@/api/report.js';
import CustomComponent from '@/views/base/custom/components/form/index.vue';
import ProductComponent from './components/product/index.vue';
import { mapActions } from 'vuex';
import PrintComponent from './components/print/index.vue';
import dayjs from 'dayjs';
import { listCustom } from '@/api/custom.js';
import util from '@/libs/util.js';
import InvoiceComponent from '@/views/components/invoice/index.vue';
import { listGender } from '@/api/dict.js';
import ExcelImportComponent from './components/import/excel.vue';
import OrderImportComponent from './components/import/order.vue';
import { parseBarCode } from '@/api/product';
import { listStockMain } from '@/api/stock.js';
export default {
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    YTable: YTable,
    CustomComponent: CustomComponent,
    ProductComponent: ProductComponent,
    PrintComponent: PrintComponent,
    InvoiceComponent: InvoiceComponent,
    ExcelImportComponent: ExcelImportComponent,
    OrderImportComponent: OrderImportComponent
  },
  data: function data() {
    return {
      formLoading: false,
      form: {
        id: null,
        attachment: [],
        clientId: null,
        distributorId: null,
        invoice: null,
        remarks: null
      },
      formRules: {
        distributorId: [{
          required: true,
          message: '请选择经销商',
          trigger: ['change', 'blur']
        }],
        operationTime: [{
          required: true,
          message: '请选择手术日期',
          trigger: ['change', 'blur']
        }]
      },
      detailRowIndex: -1,
      detailLoading: false,
      detailList: [],
      // 订单产品列表
      manufacturerList: [],
      // 经销商列表
      scanBoxDisplay: false,
      // 扫码框显示状态
      scanBarCode: null,
      // 扫码值
      tipMessage: null,
      // 提示信息
      detailForm: {
        page: 1,
        pageSize: 10,
        total: 0,
        deliveryId: null
      },
      customList: [],
      orderRow: {},
      uploadAction: process.env.VUE_APP_API + '/insideNew/upload',
      uploadToken: {},
      uploadFilePrefixURL: null,
      genderList: [],
      timestamp: new Date().valueOf()
    };
  },
  created: function created() {
    this.detailTableCacheName = 'SC-' + this.$route.name + '-detail-table';
    this.detailColumns = [{
      label: '产品编号',
      prop: 'productNumber',
      checked: true,
      width: 150,
      fixedWidth: true
    }, {
      label: '产品名称',
      prop: 'productName',
      checked: true,
      width: 150,
      fixedWidth: true
    }, {
      label: '规格型号',
      prop: 'specificationModel',
      checked: true,
      width: 150,
      fixedWidth: true
    }, {
      label: '单位',
      prop: 'unit',
      checked: true,
      width: 100
    }, {
      label: '生产批号',
      prop: 'batchNumber',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '序列号',
      prop: 'trackingCode',
      checked: true,
      width: 100,
      fixedWidth: true
    }, {
      label: '注册/备案证',
      prop: 'registrationNumber',
      checked: true,
      width: 200
    }, {
      label: '虚拟库存数',
      prop: 'stockQuantity',
      checked: true,
      width: 100
    }, {
      label: '报台数量',
      prop: 'deliveryQuantity',
      checked: true,
      width: 100,
      slot: 'deliveryQuantity',
      fixedWidth: true
    }, {
      label: '寄售单价',
      prop: 'salesUnitPrice',
      checked: true,
      width: 150,
      fixedWidth: true,
      formatter: function formatter(val) {
        return val ? val.toFixed(2) : '';
      }
    }, {
      label: '寄售金额',
      prop: 'salesAmount',
      checked: true,
      width: 150,
      fixedWidth: true,
      formatter: function formatter(val) {
        return val ? val.toFixed(2) : '';
      }
    }, {
      label: '医院单价',
      prop: 'hospitalUnitPrice',
      checked: true,
      width: 150,
      slot: 'hospitalUnitPrice',
      fixedWidth: true
    }, {
      label: '医院售价',
      prop: 'hospitalSumPrice',
      checked: true,
      width: 150
    }, {
      label: '手术日期',
      prop: 'operationTime',
      checked: true,
      width: 150,
      fixedWidth: true,
      slot: 'operationTime'
    }, {
      label: '医生姓名',
      prop: 'surgeon',
      checked: true,
      width: 150,
      fixedWidth: true,
      slot: 'surgeon'
    }, {
      label: '病人姓名',
      prop: 'patientName',
      checked: true,
      width: 150,
      fixedWidth: true,
      slot: 'patientName'
    }, {
      label: '病人性别',
      prop: 'patientGender',
      checked: true,
      width: 100,
      fixedWidth: true,
      slot: 'patientGender'
    }, {
      label: '病人年龄',
      prop: 'patientAge',
      checked: true,
      width: 100,
      fixedWidth: true,
      slot: 'patientAge'
    }, {
      label: '住院号',
      prop: 'admissionNumber',
      checked: true,
      width: 200,
      fixedWidth: true,
      slot: 'admissionNumber'
    }, {
      label: '通用名称',
      prop: 'genericName',
      checked: true,
      width: 120,
      fixedWidth: true
    }];
  },
  mounted: function mounted() {
    this.init();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, db;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.todayDate = dayjs().format('YYYY-MM-DD');
                that.detailRowIndex = -1;
                that.loading = false;
                _context.next = 6;
                return _this.database({
                  user: true
                });

              case 6:
                db = _context.sent;
                that.profile = db.get('profile').value();
                that.uploadToken = {
                  Authorization: util.cookies.get('token'),
                  Os: 'web',
                  PLATFORM: 'Web'
                };
                that.uploadFilePrefixURL = process.env.VUE_APP_OSS_URL + '/';
                that.formLoading = false;

                if (!Number(that.id)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return that.formEdit();

              case 14:
                _context.next = 17;
                break;

              case 16:
                that.formAdd();

              case 17:
                that.multiChange(that.form.multi);
                that.genderList = listGender();
                _context.next = 21;
                return that.loadManufacturer();

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    formAdd: function formAdd() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                that.form = {
                  id: null,
                  attachment: [],
                  clientId: null,
                  distributorId: null,
                  invoice: null,
                  remarks: null,
                  status: 1,
                  multi: 1,
                  surgicalName: null,
                  admissionNumber: null,
                  operationTime: null,
                  patientAge: null,
                  patientGender: '未知',
                  patientName: null,
                  surgeon: null
                };
                that.orderRow.organizationName = that.profile.organizationName;
                that.orderRow.tradeDate = dayjs().format('YYYY-MM-DD');

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    formEdit: function formEdit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, row, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                form = {
                  id: Number(that.id) || that.form.id
                };
                _context3.next = 4;
                return findReportOrder(form).then(function (res) {
                  row = res.retradeOrder;
                  that.orderRow = row;
                  that.orderRow.tradeDate = dayjs(row.tradeDate).format('YYYY-MM-DD');
                  that.form = {
                    id: row.ID,
                    attachment: row.attachment ? JSON.parse(row.attachment) : [],
                    clientId: row.clientId ? row.clientId : null,
                    distributorId: row.distributorId,
                    invoice: row.invoice,
                    remarks: row.remarks,
                    status: row.status,
                    multi: row.multi,
                    surgicalName: row.surgicalName,
                    admissionNumber: row.admissionNumber,
                    operationTime: row.operationTime,
                    patientAge: row.patientAge ? row.patientAge : null,
                    patientGender: row.patientGender,
                    patientName: row.patientName,
                    surgeon: row.surgeon
                  };
                }).catch(function (e) {});

              case 4:
                _context3.next = 6;
                return that.loadCustom();

              case 6:
                _context3.next = 8;
                return that.loadDetail();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    loadDetail: function loadDetail() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;

                if (!(!that.form.id || that.detailLoading)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                that.detailList = [];
                that.detailLoading = true;
                query = {
                  deliveryId: that.form.id,
                  page: 1,
                  pageSize: 9999
                };
                _context4.next = 8;
                return listReportOrderDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      specsId: row.specsId,
                      mainId: row.mainId,
                      batchNumber: row.inventory.batch_number,
                      trackingCode: row.inventory.trackingCode,
                      normalQuantity: row.inventory.normalQuantity,
                      productName: row.main.productName,
                      brandName: row.main.brandName,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      productNumber: row.specs.productNumber,
                      barCode: row.specs.barCode,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      admissionNumber: row.admissionNumber,
                      deliveryId: that.form.id,
                      deliveryQuantity: row.deliveryQuantity,
                      inventoryId: row.inventoryId,
                      operationTime: row.operationTime,
                      hospitalUnitPrice: row.hospitalUnitPrice,
                      hospitalSumPrice: row.hospitalSumPrice,
                      patientAge: row.patientAge ? row.patientAge : null,
                      patientGender: row.patientGender,
                      patientName: row.patientName,
                      remarks: row.remarks,
                      surgeon: row.surgeon,
                      stockQuantity: row.inventory.stock_quantity,
                      salesUnitPrice: row.salesUnitPrice,
                      salesAmount: row.salesAmount,
                      genericName: row.specs.genericName
                    });
                  });
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.detailTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 8:
                that.detailLoading = false;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    loadManufacturer: function loadManufacturer() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context5.next = 4;
                return listDealerUserManufacturer(query).then(function (res) {
                  that.manufacturerList = res.list;
                }).catch(function (e) {});

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadCustom: function loadCustom() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                that.customList = [];
                query = {
                  page: 1,
                  pageSize: 9999,
                  manuId: that.form.distributorId
                };
                _context6.next = 5;
                return listCustom(query).then(function (res) {
                  that.customList = res.list;
                }).catch(function (e) {});

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    excelImport: function excelImport() {
      var that = this;
      that.$refs.ExcelImportComponentRef.init({
        distributorId: that.form.distributorId
      });
    },
    orderImport: function orderImport() {
      var that = this;
      that.$refs.OrderImportComponentRef.init();
    },
    quantitySum: function quantitySum() {
      var that = this;
      var num = 0;
      that.detailList.map(function (item) {
        num += item.deliveryQuantity;
      });
      return num;
    },
    amountSum: function amountSum() {
      var that = this;
      var amount = 0;
      that.detailList.forEach(function (item) {
        amount += Number(item.hospitalSumPrice) === NaN ? 0 : Number(item.hospitalSumPrice);
        console.log('item.hospitalSumPrice', item.hospitalSumPrice);
      });
      return Number(amount).toFixed(2);
    },
    scanBoxDisplaySwitch: function scanBoxDisplaySwitch() {
      var that = this;
      that.scanBoxDisplay = !that.scanBoxDisplay;

      if (that.scanBoxDisplay) {
        that.$nextTick(function () {
          that.$refs.scanInputBoxRef.focus();
        });
      }
    },
    barCodeSearch: function barCodeSearch() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that, parseQuery, parseRes, stockQuery, stockRes, rows;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;

                if (that.form.distributorId) {
                  _context7.next = 4;
                  break;
                }

                that.$message.error('请选择经销商');
                return _context7.abrupt("return");

              case 4:
                if (!that.scanBarCode) {
                  _context7.next = 26;
                  break;
                }

                if (!(that.scanBarCode.substr(0, 2) === '01')) {
                  _context7.next = 24;
                  break;
                }

                _context7.prev = 6;
                parseQuery = {
                  di: null,
                  dipi: null
                };

                if (that.scanBarCode.length > 20) {
                  parseQuery.dipi = that.scanBarCode;
                } else {
                  parseQuery.di = that.scanBarCode;
                }

                _context7.next = 11;
                return parseBarCode(parseQuery);

              case 11:
                parseRes = _context7.sent;
                stockQuery = {
                  barCode: parseRes.barCode,
                  batch_number: parseRes.batch_number,
                  trackingCode: parseRes.tracking_code,
                  manufacturerId4: that.form.distributorId,
                  isVirtualWarehouse: 2,
                  page: 1,
                  pageSize: 1
                };
                _context7.next = 15;
                return listStockMain(stockQuery);

              case 15:
                stockRes = _context7.sent;

                if (stockRes.total === 1) {
                  rows = [];
                  stockRes.list.map(function (row) {
                    rows.push({
                      ID: null,
                      specsId: row.specs_id,
                      mainId: row.main_id,
                      deliveryQuantity: 1,
                      hospitalUnitPrice: 0,
                      hospitalAmount: 0,
                      remarks: null,
                      productName: row.main.productName,
                      batchNumber: row.batch_number,
                      brandName: row.main.brandName,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      inventoryId: row.ID,
                      normalQuantity: row.normalQuantity,
                      stockQuantity: row.stock_quantity,
                      trackingCode: row.trackingCode,
                      productNumber: row.specs.productNumber || null,
                      barCode: row.specs.barCode || null,
                      specificationModel: row.specs.specificationModel || null,
                      unit: row.specs.unit || null,
                      wholesalePurchasePrice: row.specs.wholesalePurchasePrice || 0,
                      consignmentPurchasePrice: row.specs.consignmentPurchasePrice || 0,
                      marketPrice: row.specs.marketPrice || 0,
                      consignmentPrice: row.specs.consignmentPrice || 0,
                      wholesalePrice: row.specs.wholesalePrice || 0,
                      onlPrice: row.specs.onlPrice || 0,
                      lowPrice: row.specs.lowPrice || 0,
                      checked: false,
                      genericName: row.specs.genericName
                    });
                  });
                  that.addProductToDetailList(rows);
                } else if (stockRes.total > 1) {
                  that.$refs.ProductComponentRef.init({
                    distributorId: that.form.distributorId,
                    barCode: parseRes.barCode,
                    batchNumber: parseRes.batch_number,
                    trackingCode: parseRes.tracking_code
                  });
                } else if (stockRes.total === 0) {
                  that.$message.error('没有找到相关产品：' + that.scanBarCode);
                }

                that.scanBarCode = null;
                _context7.next = 22;
                break;

              case 20:
                _context7.prev = 20;
                _context7.t0 = _context7["catch"](6);

              case 22:
                _context7.next = 26;
                break;

              case 24:
                that.scanBarCode = '01' + that.scanBarCode;
                that.barCodeSearch();

              case 26:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[6, 20]]);
      }))();
    },
    orderPrint: function orderPrint() {
      var that = this;
      that.$refs.PrintComponentRef.init(that.form.id);
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page;

      if (that.detailRowIndex >= 0) {
        var pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

        if (that.detailRowIndex > pageRows.length - 1) {
          that.detailRowIndex = pageRows.length - 1;
        }

        var row = pageRows[that.detailRowIndex];
        that.$refs.dataTableRef.setCurrentRow(row, true);
      }
    },
    detailSizeChange: function detailSizeChange(pageSize) {
      var that = this;
      that.detailForm.pageSize = pageSize;
      that.detailForm.page = 1;
    },
    detailRowClick: function detailRowClick(row, column, event) {
      var that = this;
      var pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);
      var index = pageRows.indexOf(row);

      if (index >= 0) {
        that.detailRowIndex = index;
      } else {
        that.detailRowIndex = -1;
      }
    },
    newCustom: function newCustom() {
      var that = this;
      var row = {
        id: null,
        manuId: that.form.distributorId
      };
      that.$refs.CustomComponentRef.init(row);
    },
    formStorage: function formStorage(showMessage) {
      var _this8 = this;

      var that = this;
      that.$refs.form.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(valid, err) {
          var loading, form, res, item;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (!valid) {
                    _context8.next = 29;
                    break;
                  }

                  loading = _this8.$loading({
                    text: '订单暂存中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  _context8.prev = 2;
                  form = JSON.parse(JSON.stringify(that.form));

                  if (!form.attachment) {
                    form.attachment = [];
                  }

                  form.attachment = JSON.stringify(form.attachment);

                  if (form.multi === 2) {
                    form = _objectSpread(_objectSpread({}, form), {}, {
                      clientId: form.clientId ? form.clientId : null,
                      surgicalName: null,
                      admissionNumber: null,
                      operationTime: null,
                      patientAge: null,
                      patientGender: null,
                      patientName: null,
                      surgeon: null
                    });
                  } else {
                    form.patientAge = form.patientAge ? Number(form.patientAge) : 0;
                  }

                  if (!form.id) {
                    _context8.next = 12;
                    break;
                  }

                  _context8.next = 10;
                  return updateReportOrder(form);

                case 10:
                  _context8.next = 16;
                  break;

                case 12:
                  _context8.next = 14;
                  return createReportOrder(form);

                case 14:
                  res = _context8.sent;
                  that.form.id = res.ID;

                case 16:
                  _context8.next = 18;
                  return that.productSaveAll();

                case 18:
                  _context8.next = 20;
                  return that.loadDetail();

                case 20:
                  if (showMessage) {
                    that.$notify.success('暂存成功');
                  }

                  _context8.next = 26;
                  break;

                case 23:
                  _context8.prev = 23;
                  _context8.t0 = _context8["catch"](2);
                  console.log(_context8.t0.message);

                case 26:
                  loading.close();
                  _context8.next = 36;
                  break;

                case 29:
                  _context8.t1 = regeneratorRuntime.keys(err);

                case 30:
                  if ((_context8.t2 = _context8.t1()).done) {
                    _context8.next = 36;
                    break;
                  }

                  item = _context8.t2.value;

                  _this8.$message.error(err[item][0].message);

                  return _context8.abrupt("return");

                case 36:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[2, 23]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    formSubmit: function formSubmit() {
      var _this9 = this;

      var that = this;

      if (that.detailList.length === 0) {
        that.$message.error('请添加产品');
        return;
      }

      if (that.form.multi === 2) {
        var errLine = [];
        that.detailList.forEach(function (row, index) {
          if (!row.operationTime) {
            errLine.push(index + 1);
          }
        });

        if (errLine.length > 0) {
          that.$message.error('请选择手术日期（序号为' + errLine.toString() + '）');
          return;
        }

        that.formRules.operationTime[0].required = false;
      } else {
        that.formRules.operationTime[0].required = true;
      }

      that.$refs.form.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(valid, err) {
          var loading, form, res, submitForm, item;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (!valid) {
                    _context9.next = 34;
                    break;
                  }

                  loading = _this9.$loading({
                    text: '订单提交中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  _context9.prev = 2;
                  form = JSON.parse(JSON.stringify(that.form));

                  if (!form.attachment) {
                    form.attachment = [];
                  }

                  form.attachment = JSON.stringify(form.attachment);

                  if (form.multi === 2) {
                    form = _objectSpread(_objectSpread({}, form), {}, {
                      clientId: form.clientId ? form.clientId : null,
                      surgicalName: null,
                      admissionNumber: null,
                      operationTime: null,
                      patientAge: null,
                      patientGender: null,
                      patientName: null,
                      surgeon: null
                    });
                  } else {
                    form.patientAge = form.patientAge ? Number(form.patientAge) : 0;
                  }

                  if (!form.id) {
                    _context9.next = 12;
                    break;
                  }

                  _context9.next = 10;
                  return updateReportOrder(form);

                case 10:
                  _context9.next = 17;
                  break;

                case 12:
                  _context9.next = 14;
                  return createReportOrder(form);

                case 14:
                  res = _context9.sent;
                  that.form.id = res.ID;
                  form.id = res.ID;

                case 17:
                  _context9.next = 19;
                  return that.productSaveAll();

                case 19:
                  // 提交订单
                  submitForm = {
                    id: that.form.id,
                    status: 2
                  };
                  _context9.next = 22;
                  return updateReportOrderState(submitForm);

                case 22:
                  _context9.next = 24;
                  return that.loadDetail();

                case 24:
                  that.$notify.success('提交成功');
                  that.formEdit();
                  _context9.next = 31;
                  break;

                case 28:
                  _context9.prev = 28;
                  _context9.t0 = _context9["catch"](2);
                  console.log(_context9.t0.message);

                case 31:
                  loading.close();
                  _context9.next = 41;
                  break;

                case 34:
                  _context9.t1 = regeneratorRuntime.keys(err);

                case 35:
                  if ((_context9.t2 = _context9.t1()).done) {
                    _context9.next = 41;
                    break;
                  }

                  item = _context9.t2.value;

                  _this9.$message.error(err[item][0].message);

                  return _context9.abrupt("return");

                case 41:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, null, [[2, 28]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    productSaveAll: function productSaveAll() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var that;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                that = _this10;
                return _context10.abrupt("return", new Promise(function (resolve, reject) {
                  var saveRows = that.detailList.filter(function (item) {
                    return !item.ID;
                  });

                  if (saveRows.length > 0) {
                    var form = [];
                    saveRows.map(function (row) {
                      form.push({
                        deliveryId: that.form.id,
                        deliveryQuantity: row.deliveryQuantity,
                        inventoryId: row.inventoryId,
                        hospitalUnitPrice: row.hospitalUnitPrice,
                        remarks: row.remarks,
                        admissionNumber: that.form.multi === 2 ? row.admissionNumber : null,
                        operationTime: that.form.multi === 2 ? row.operationTime : null,
                        patientAge: that.form.multi === 2 ? Number(row.patientAge) : 0,
                        patientGender: that.form.multi === 2 ? row.patientGender : null,
                        patientName: that.form.multi === 2 ? row.patientName : null,
                        surgeon: that.form.multi === 2 ? row.surgeon : null
                      });
                    });
                    createReportOrderDetails(form).then(function (res) {
                      resolve('SUCCESS');
                    }).catch(function (e) {
                      reject(new Error(e.message));
                    });
                  } else {
                    resolve('SUCCESS');
                  }
                }));

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    productRemove: function productRemove() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that, pageRows, row, index, currentRow, _currentRow;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this11;
                _context11.prev = 1;
                pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

                if (!(that.detailRowIndex >= 0)) {
                  _context11.next = 12;
                  break;
                }

                row = pageRows[that.detailRowIndex];
                index = that.detailList.indexOf(row);

                if (!row.ID) {
                  _context11.next = 9;
                  break;
                }

                _context11.next = 9;
                return deleteReportOrderDetail({
                  ID: row.ID
                });

              case 9:
                that.detailList.splice(index, 1);
                pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

                if (pageRows.length >= 1) {
                  if (that.detailRowIndex > pageRows.length - 1) {
                    that.detailRowIndex = pageRows.length - 1;
                  }

                  currentRow = pageRows[that.detailRowIndex];
                  that.$nextTick(function () {
                    that.$refs.dataTableRef.setCurrentRow(currentRow, true);
                  });
                } else {
                  if (that.detailForm.page > 1) {
                    that.detailForm.page = that.detailForm.page - 1;
                    pageRows = that.detailList.slice((that.detailForm.page - 1) * that.detailForm.pageSize, that.detailForm.page * that.detailForm.pageSize);

                    if (that.detailRowIndex > pageRows.length - 1) {
                      that.detailRowIndex = pageRows.length - 1;
                    }

                    _currentRow = pageRows[that.detailRowIndex];
                    that.$nextTick(function () {
                      that.$refs.dataTableRef.setCurrentRow(_currentRow, true);
                    });
                  } else {
                    that.detailRowIndex = -1;
                  }
                }

              case 12:
                that.detailForm.total = that.detailList.length;
                _context11.next = 17;
                break;

              case 15:
                _context11.prev = 15;
                _context11.t0 = _context11["catch"](1);

              case 17:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[1, 15]]);
      }))();
    },
    addProduct: function addProduct() {
      var that = this;

      if (!that.form.distributorId) {
        that.$message.error('请选择经销商');
        return;
      }

      that.$refs.ProductComponentRef.init({
        distributorId: that.form.distributorId
      });
    },
    // 添加产品到detailList列表中
    addProductToDetailList: function addProductToDetailList(rows) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var that, newNum;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                that = _this12;

                if (!(rows.length === 0)) {
                  _context12.next = 4;
                  break;
                }

                that.$message.error('未选择要添加的产品');
                return _context12.abrupt("return");

              case 4:
                newNum = rows.length;
                rows.map(function (item) {
                  item.patientAge = null;
                  that.detailList.push(JSON.parse(JSON.stringify(item)));
                });
                that.detailForm.total = that.detailList.length;

                if (!that.form.id) {
                  _context12.next = 22;
                  break;
                }

                _context12.prev = 8;
                _context12.next = 11;
                return that.productSaveAll();

              case 11:
                _context12.next = 13;
                return that.loadDetail();

              case 13:
                that.$notify({
                  type: 'success',
                  dangerouslyUseHTMLString: true,
                  message: '新增' + newNum + '个产品'
                });
                _context12.next = 20;
                break;

              case 16:
                _context12.prev = 16;
                _context12.t0 = _context12["catch"](8);
                _context12.next = 20;
                return that.loadDetail();

              case 20:
                _context12.next = 23;
                break;

              case 22:
                that.$notify({
                  type: 'success',
                  dangerouslyUseHTMLString: true,
                  message: '新增' + newNum + '个产品'
                });

              case 23:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[8, 16]]);
      }))();
    },
    productSaveOne: function productSaveOne(row) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var that, form, query;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                that = _this13;
                row.hospitalSumPrice = Number(row.hospitalUnitPrice * row.deliveryQuantity).toFixed(2);
                row.hospitalSumPrice = Number(row.hospitalSumPrice);
                row.salesAmount = Number(row.salesUnitPrice * row.deliveryQuantity).toFixed(2);
                row.salesAmount = Number(row.salesAmount);
                console.log('row.hospitalSumPrice', row.hospitalSumPrice);
                that.$forceUpdate();

                if (!that.form.id) {
                  _context13.next = 26;
                  break;
                }

                _context13.prev = 8;
                form = {
                  id: row.ID,
                  deliveryId: that.form.id,
                  deliveryQuantity: row.deliveryQuantity,
                  inventoryId: row.inventoryId,
                  hospitalUnitPrice: row.hospitalUnitPrice,
                  admissionNumber: that.form.multi === 2 ? row.admissionNumber : null,
                  operationTime: that.form.multi === 2 ? row.operationTime : null,
                  patientAge: that.form.multi === 2 ? Number(row.patientAge) : 0,
                  patientGender: that.form.multi === 2 ? row.patientGender : null,
                  patientName: that.form.multi === 2 ? row.patientName : null,
                  surgeon: that.form.multi === 2 ? row.surgeon : null,
                  remarks: row.remarks
                };

                if (!form.id) {
                  _context13.next = 15;
                  break;
                }

                _context13.next = 13;
                return updateReportOrderDetail(form);

              case 13:
                _context13.next = 19;
                break;

              case 15:
                _context13.next = 17;
                return createReportOrderDetails([form]);

              case 17:
                _context13.next = 19;
                return that.loadDetail();

              case 19:
                _context13.next = 26;
                break;

              case 21:
                _context13.prev = 21;
                _context13.t0 = _context13["catch"](8);
                // 更新失败，查询原数据恢复
                query = {
                  id: row.ID
                };
                _context13.next = 26;
                return findReportOrderDetail(query).then(function (res) {
                  var remoteRow = res.retradeDetail;
                  console.log('remoteRow', remoteRow);
                  row.deliveryQuantity = remoteRow.deliveryQuantity;
                  row.remarks = remoteRow.remarks;
                });

              case 26:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[8, 21]]);
      }))();
    },
    distributorIdChange: function distributorIdChange() {
      var that = this;
      that.form.clientId = null;
      that.loadCustom();
    },
    orderDelete: function orderDelete() {
      var that = this;
      that.$confirm('确定要作废吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var form;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                form = {
                  ID: that.form.id
                };
                deleteReportOrder(form).then(function () {
                  that.$notify.success('订单删除成功');
                  that.returnList();
                });

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))).catch(function () {});
    },
    returnList: function returnList() {
      var that = this;
      that.$store.dispatch('d2admin/page/close', {
        tagName: that.$route.fullPath
      });
      that.$router.push({
        path: '/order/consign'
      });
    },
    attachRemove: function attachRemove(row) {
      var that = this;
      that.form.attachment.splice(that.form.attachment.indexOf(row), 1);
    },
    attachPreview: function attachPreview(row) {
      var that = this;
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = that.uploadFilePrefixURL + row.url;
      link.setAttribute('download', row.name);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
    attachSuccess: function attachSuccess(res, file, fileList) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var that;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                that = _this14;
                that.form.attachment.push({
                  url: file.response.data.file.url,
                  name: file.response.data.file.name
                });
                _context15.next = 4;
                return that.formStorage();

              case 4:
                that.$notify.success('上传成功，请记得点一下【暂存】保存已上传的附件');

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    invoiceAdd: function invoiceAdd() {
      var that = this;
      that.$refs.InvoiceComponentRef.init();
    },
    genderFormatter: function genderFormatter(val) {
      var that = this;
      var findRow = that.genderList.find(function (item) {
        return item.ID === val;
      });

      if (findRow) {
        return findRow.name;
      } else {
        return val;
      }
    },
    multiChange: function multiChange(val) {
      var that = this;
      that.detailColumns.map(function (row) {
        if (['surgicalName', 'admissionNumber', 'operationTime', 'patientAge', 'patientGender', 'patientName', 'surgeon'].includes(row.prop)) {
          console.log('包含', row.prop);

          if (val === 1) {
            that.$set(row, 'checked', false);
          } else if (val === 2) {
            that.$set(row, 'checked', true);
          }
        }
      });
      that.timestamp = new Date().valueOf();
    }
  })
};